import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '../../../helpers'
import { Organization } from '../../../models'

const ADMIN_FILTER_ORGANIZATIONS_KEY = 'admin-filter-organizations'

const buildOrganizationFilterParams = (hasBillingSetup: boolean) => ({
    apartment_only: true as const,
    ...(hasBillingSetup ? { has_billing_setup: true as const } : {}),
})

/** Organizations for admin property filters; excludes archived (endpoint default). */
export const useAdminFilterOrganizations = (hasBillingSetup: boolean) => {
    const params = buildOrganizationFilterParams(hasBillingSetup)

    const { data, isLoading, isError, error, refetch } = useQuery<
        Organization[],
        Error
    >({
        queryKey: [ADMIN_FILTER_ORGANIZATIONS_KEY, params],
        queryFn: async () => {
            const response = await axiosInstance.get<Organization[]>(
                'company/organization/',
                { params },
            )
            return response.data
        },
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
    })

    return {
        organizations: data ?? [],
        isLoading,
        isError,
        error,
        refetch,
    }
}
